module.exports = __webpack_public_path__ + "static/img/一站式供应链服务@2x.718f4b98.png";